<div class="layout-box" igxLayout igxLayoutDir="column" style="width: 100%; height: 535px;">
  <div class="layout-box__el3" igxFlex>
    <div class="layout-box" igxLayout>
      <div class="layout-box__el" igxFlex style="width: 85%">
        <app-busqueda-libro #busquedaLibroCH [mostrarBtnVistaPrevia]="false"
                            [titleSubirArchivo]="'TITULOS.SUBIR_COSTO_HORARIO'" [desactivarBtnSubirArchivo]="esMaestro"
                            [titleBajarArchivo]="'TITULOS.DESCARGAR_COSTO_HORARIO'"
                            [desactivarBtnBajarArchivo]="esMaestro"
                            [etiquetaInput]="'MENSAJES.GRALS.LIBRO_COSTO_HORARIO'"
                            [desactivarBtnBuscarLibro]="esMaestro"></app-busqueda-libro>
      </div>
      <div class="layout-box__el" igxFlex style="width: 15%">
        <app-select-moneda #selectMonedas (selectionChanging)="handleSelection($event)" [width]="'100%'"></app-select-moneda>
      </div>
    </div>
    <div class="layout-box" igxLayout style="padding-top: 8px">
      <igx-tabs #tabGeneral (selectedIndexChanging)="cambioTab($event)" tabAlignment="center"
                style="width: 100%;" [style.height]="isMobileHeight ? '400px': '456px'">
        <igx-tab-item>
          <igx-tab-header>
            <span igxTabHeaderLabel>{{ 'MENSAJES.GRALS.CHDATOS' | translate }}</span>
          </igx-tab-header>
          <igx-tab-content style="padding-top: 10px">
            <div class="layout-box" igxLayout style="padding-top: 2px;">
              <div class="layout-box" igxLayout igxLayoutDir="row">
                <div class="layout-box__el" igxFlex style="width: 25%">
                  <igx-input-group>
                    <input igxInput type="text" [disabled]="true"/>
                    <label igxLabel>{{ 'MENSAJES.GRALS.CHCARGOFIJOACTIVO' | translate }}*:</label>
                    <igx-suffix></igx-suffix>
                  </igx-input-group>
                </div>
                <div class="layout-box__el" igxFlex style="width: 20%">
                  <app-tres-puntos #tresPuntosCFA [tipoCatalogo]="EnumTresPuntos.CatalogoGeneral" [etiqueta]="'GRIDS.EXP_INSUMO.COL_CODIGO'"
                                   [porcentaje]="100" [verLimpiar]="false" [agregarCodigo]="true"
                                   [filtrarTipo]="[3]" (eventFilaSeleccionada)="filaSeleccionada($event, 0)"
                                   (eventAgregarCodigo)="agregarCodigo($event, 0)" [readOnlyInput]="false"
                                   [desactivarInput]="esMaestro" [hiddenBtn]="esMaestro"></app-tres-puntos>
                </div>
                <div class="layout-box__el" igxFlex style="width: 40%">
                  <igx-input-group>
                    <input #desCFA igxInput type="text" [disabled]="esMaestro"/>
                    <label igxLabel>{{ 'GRIDS.EXP_INSUMO.COL_DESCRIPCION_LARGA' | translate }}:</label>
                    <igx-suffix></igx-suffix>
                  </igx-input-group>
                </div>
                <div class="layout-box__el" igxFlex style="width: 15%">
                  <app-tres-puntos #tresPuntosUniCFA [tipoCatalogo]="EnumTresPuntos.Unidades" [etiqueta]="'GRIDS.EXP_INSUMO.COL_UNIDAD'"
                                   [porcentaje]="100" [verLimpiar]="false"
                                   [readOnlyInput]="false" [desactivarInput]="esMaestro"
                                   [hiddenBtn]="esMaestro"></app-tres-puntos>
                </div>
                <div class="layout-box__el" igxFlex>
                  <igx-input-group>
                    <input #costoCFA id="costoCFA" igxInput class="rightInput" type="text" [disabled]="true"/>
                    <label igxLabel>{{ 'MENSAJES.GRALS.COSTO' | translate }}:</label>
                    <igx-suffix></igx-suffix>
                  </igx-input-group>
                </div>
              </div>
            </div>
            <div class="layout-box" igxLayout style="padding-top: 2px;">
              <div class="layout-box" igxLayout igxLayoutDir="row">
                <div class="layout-box__el" igxFlex style="width: 25%">
                  <igx-input-group>
                    <input igxInput type="text" [disabled]="true"/>
                    <label igxLabel>{{ 'MENSAJES.GRALS.CHESPERA' | translate }}:</label>
                    <igx-suffix></igx-suffix>
                  </igx-input-group>
                </div>
                <div class="layout-box__el" igxFlex style="width: 20%">
                  <app-tres-puntos #tresPuntosEspera [tipoCatalogo]="EnumTresPuntos.CatalogoGeneral" [etiqueta]="'GRIDS.EXP_INSUMO.COL_CODIGO'"
                                   [porcentaje]="100" [verLimpiar]="false" [agregarCodigo]="true"
                                   [filtrarTipo]="[3]" (eventFilaSeleccionada)="filaSeleccionada($event, 1)"
                                   (eventAgregarCodigo)="agregarCodigo($event, 1)" [readOnlyInput]="false"
                                   [desactivarInput]="esMaestro" [hiddenBtn]="esMaestro"></app-tres-puntos>
                </div>
                <div class="layout-box__el" igxFlex style="width: 40%">
                  <igx-input-group>
                    <input #desEspera igxInput type="text" [disabled]="esMaestro"/>
                    <label igxLabel>{{ 'GRIDS.EXP_INSUMO.COL_DESCRIPCION_LARGA' | translate }}:</label>
                    <igx-suffix></igx-suffix>
                  </igx-input-group>
                </div>
                <div class="layout-box__el" igxFlex style="width: 15%">
                  <app-tres-puntos #tresPuntosUniEspera [tipoCatalogo]="EnumTresPuntos.Unidades" [etiqueta]="'GRIDS.EXP_INSUMO.COL_UNIDAD'"
                                   [porcentaje]="100" [verLimpiar]="false"
                                   [readOnlyInput]="false" [desactivarInput]="esMaestro"
                                   [hiddenBtn]="esMaestro"></app-tres-puntos>
                </div>
                <div class="layout-box__el" igxFlex>
                  <igx-input-group>
                    <input #costoEspera id="costoEspera" igxInput class="rightInput" type="text" [disabled]="true"/>
                    <label igxLabel>{{ 'MENSAJES.GRALS.COSTO' | translate }}:</label>
                    <igx-suffix></igx-suffix>
                  </igx-input-group>
                </div>
              </div>
            </div>
            <div class="layout-box" igxLayout style="padding-top: 2px;">
              <div class="layout-box" igxLayout igxLayoutDir="row">
                <div class="layout-box__el" igxFlex style="width: 25%">
                  <igx-input-group>
                    <input igxInput type="text" [disabled]="true"/>
                    <label igxLabel>{{ 'MENSAJES.GRALS.CHRESERVA' | translate }}:</label>
                    <igx-suffix></igx-suffix>
                  </igx-input-group>
                </div>
                <div class="layout-box__el" igxFlex style="width: 20%">
                  <app-tres-puntos #tresPuntosReserva [tipoCatalogo]="EnumTresPuntos.CatalogoGeneral" [etiqueta]="'GRIDS.EXP_INSUMO.COL_CODIGO'"
                                   [porcentaje]="100" [verLimpiar]="false" [agregarCodigo]="true"
                                   [filtrarTipo]="[3]" (eventFilaSeleccionada)="filaSeleccionada($event, 2)"
                                   (eventAgregarCodigo)="agregarCodigo($event, 2)" [readOnlyInput]="false"
                                   [desactivarInput]="esMaestro" [hiddenBtn]="esMaestro"></app-tres-puntos>
                </div>
                <div class="layout-box__el" igxFlex style="width: 40%">
                  <igx-input-group>
                    <input #desReserva igxInput type="text" [disabled]="esMaestro"/>
                    <label igxLabel>{{ 'GRIDS.EXP_INSUMO.COL_DESCRIPCION_LARGA' | translate }}:</label>
                    <igx-suffix></igx-suffix>
                  </igx-input-group>
                </div>
                <div class="layout-box__el" igxFlex style="width: 15%">
                  <app-tres-puntos #tresPuntosUniReserva [tipoCatalogo]="EnumTresPuntos.Unidades" [etiqueta]="'GRIDS.EXP_INSUMO.COL_UNIDAD'"
                                   [porcentaje]="100" [verLimpiar]="false"
                                   [readOnlyInput]="false" [desactivarInput]="esMaestro"
                                   [hiddenBtn]="esMaestro"></app-tres-puntos>
                </div>
                <div class="layout-box__el" igxFlex>
                  <igx-input-group>
                    <input #costoReserva id="costoReserva" igxInput class="rightInput" type="text"
                           [disabled]="true"/>
                    <label igxLabel>{{ 'MENSAJES.GRALS.COSTO' | translate }}:</label>
                    <igx-suffix></igx-suffix>
                  </igx-input-group>
                </div>
              </div>
            </div>
            <div class="layout-box" igxLayout style="padding-top: 2px;">
              <div class="layout-box" igxLayout igxLayoutDir="row">
                <div class="layout-box__el" igxFlex style="width: 25%">
                  <igx-input-group>
                    <input igxInput type="text" [disabled]="true"/>
                    <label igxLabel>{{ 'MENSAJES.GRALS.CHVALORADQ' | translate }}:</label>
                    <igx-suffix></igx-suffix>
                  </igx-input-group>
                </div>
                <div class="layout-box__el" igxFlex style="width: 20%">
                  <app-tres-puntos #tresPuntosValorAdq [tipoCatalogo]="EnumTresPuntos.CatalogoGeneral" [etiqueta]="'GRIDS.EXP_INSUMO.COL_CODIGO'"
                                   [porcentaje]="100" [verLimpiar]="false" [agregarCodigo]="true"
                                   (eventFilaSeleccionada)="filaSeleccionada($event, 3)"
                                   (eventAgregarCodigo)="agregarCodigo($event, 3)" [readOnlyInput]="false"
                                   [desactivarInput]="esMaestro" [hiddenBtn]="esMaestro"></app-tres-puntos>
                </div>
                <div class="layout-box__el" igxFlex style="width: 40%">
                  <igx-input-group>
                    <input #desValorAdq igxInput type="text" [disabled]="esMaestro"/>
                    <label igxLabel>{{ 'GRIDS.EXP_INSUMO.COL_DESCRIPCION_LARGA' | translate }}:</label>
                    <igx-suffix></igx-suffix>
                  </igx-input-group>
                </div>
                <div class="layout-box__el" igxFlex style="width: 15%">
                  <app-tres-puntos #tresPuntosUniValorAdq [tipoCatalogo]="EnumTresPuntos.Unidades" [etiqueta]="'GRIDS.EXP_INSUMO.COL_UNIDAD'"
                                   [porcentaje]="100" [verLimpiar]="false"
                                   [readOnlyInput]="false" [desactivarInput]="esMaestro"
                                   [hiddenBtn]="esMaestro"></app-tres-puntos>
                </div>
                <div class="layout-box__el" igxFlex>
                  <igx-input-group>
                    <input #costoValorAdq id="costoValorAdq" igxInput class="rightInput" type="text"
                           [igxTextSelection]="true" [disabled]="esMaestro"
                           (blur)="regenerarFormato($event, true, true, this.formatDecImporte.digitsInfo)"/>
                    <label igxLabel>{{ 'MENSAJES.GRALS.COSTO' | translate }}:</label>
                    <igx-suffix></igx-suffix>
                  </igx-input-group>
                </div>
              </div>
            </div>
            <div class="layout-box" igxLayout style="padding-top: 2px;">
              <div class="layout-box" igxLayout igxLayoutDir="row">
                <div class="layout-box__el" igxFlex style="width: 25%">
                  <igx-input-group>
                    <input igxInput type="text" [disabled]="true"/>
                    <label igxLabel>{{ 'MENSAJES.GRALS.CHLLANTAS' | translate }}:</label>
                    <igx-suffix></igx-suffix>
                  </igx-input-group>
                </div>
                <div class="layout-box__el" igxFlex style="width: 20%">
                  <app-tres-puntos #tresPuntosLlantas [tipoCatalogo]="EnumTresPuntos.CatalogoGeneral" [etiqueta]="'GRIDS.EXP_INSUMO.COL_CODIGO'"
                                   [porcentaje]="100" [verLimpiar]="false" [agregarCodigo]="true"
                                   (eventFilaSeleccionada)="filaSeleccionada($event, 4)"
                                   (eventAgregarCodigo)="agregarCodigo($event, 4)" [readOnlyInput]="false"
                                   [desactivarInput]="esMaestro" [hiddenBtn]="esMaestro"></app-tres-puntos>
                </div>
                <div class="layout-box__el" igxFlex style="width: 40%">
                  <igx-input-group>
                    <input #desLlantas igxInput type="text" [disabled]="esMaestro"/>
                    <label igxLabel>{{ 'GRIDS.EXP_INSUMO.COL_DESCRIPCION_LARGA' | translate }}:</label>
                    <igx-suffix></igx-suffix>
                  </igx-input-group>
                </div>
                <div class="layout-box__el" igxFlex style="width: 15%">
                  <app-tres-puntos #tresPuntosUniLlantas [tipoCatalogo]="EnumTresPuntos.Unidades" [etiqueta]="'GRIDS.EXP_INSUMO.COL_UNIDAD'"
                                   [porcentaje]="100" [verLimpiar]="false"
                                   [readOnlyInput]="false" [desactivarInput]="esMaestro"
                                   [hiddenBtn]="esMaestro"></app-tres-puntos>
                </div>
                <div class="layout-box__el" igxFlex>
                  <igx-input-group>
                    <input #costoLlantas id="costoLlantas" igxInput class="rightInput" type="text"
                           [igxTextSelection]="true" [disabled]="esMaestro"
                           (blur)="regenerarFormato($event, true, true, this.formatDecImporte.digitsInfo)"/>
                    <label igxLabel>{{ 'MENSAJES.GRALS.COSTO' | translate }}:</label>
                    <igx-suffix></igx-suffix>
                  </igx-input-group>
                </div>
              </div>
            </div>
            <div class="layout-box" igxLayout style="padding-top: 2px;">
              <div class="layout-box" igxLayout igxLayoutDir="row">
                <div class="layout-box__el" igxFlex style="width: 25%">
                  <igx-input-group>
                    <input igxInput type="text" [disabled]="true"/>
                    <label igxLabel>{{ 'MENSAJES.GRALS.CHPIEZASESPECIALES' | translate }}:</label>
                    <igx-suffix></igx-suffix>
                  </igx-input-group>
                </div>
                <div class="layout-box__el" igxFlex style="width: 20%">
                  <app-tres-puntos #tresPuntosPzaEsp [tipoCatalogo]="EnumTresPuntos.CatalogoGeneral" [etiqueta]="'GRIDS.EXP_INSUMO.COL_CODIGO'"
                                   [porcentaje]="100" [verLimpiar]="false" [agregarCodigo]="true"
                                   (eventFilaSeleccionada)="filaSeleccionada($event, 5)"
                                   (eventAgregarCodigo)="agregarCodigo($event, 5)" [readOnlyInput]="false"
                                   [desactivarInput]="esMaestro" [hiddenBtn]="esMaestro"></app-tres-puntos>
                </div>
                <div class="layout-box__el" igxFlex style="width: 40%">
                  <igx-input-group>
                    <input #desPzaEsp igxInput type="text" [disabled]="esMaestro"/>
                    <label igxLabel>{{ 'GRIDS.EXP_INSUMO.COL_DESCRIPCION_LARGA' | translate }}:</label>
                    <igx-suffix></igx-suffix>
                  </igx-input-group>
                </div>
                <div class="layout-box__el" igxFlex style="width: 15%">
                  <app-tres-puntos #tresPuntosUniPzaEsp [tipoCatalogo]="EnumTresPuntos.Unidades" [etiqueta]="'GRIDS.EXP_INSUMO.COL_UNIDAD'"
                                   [porcentaje]="100" [verLimpiar]="false"
                                   [readOnlyInput]="false" [desactivarInput]="esMaestro"
                                   [hiddenBtn]="esMaestro"></app-tres-puntos>
                </div>
                <div class="layout-box__el" igxFlex>
                  <igx-input-group>
                    <input #costoPzaEsp id="costoPzaEsp" igxInput class="rightInput" type="text"
                           [igxTextSelection]="true" [disabled]="esMaestro"
                           (blur)="regenerarFormato($event, true, true, this.formatDecImporte.digitsInfo)"/>
                    <label igxLabel>{{ 'MENSAJES.GRALS.COSTO' | translate }}:</label>
                    <igx-suffix></igx-suffix>
                  </igx-input-group>
                </div>
              </div>
            </div>
            <div class="layout-box" igxLayout style="padding-top: 2px;">
              <div class="layout-box" igxLayout igxLayoutDir="row">
                <div class="layout-box__el" igxFlex style="width: 25%">
                  <igx-input-group>
                    <input igxInput type="text" [disabled]="true"/>
                    <label igxLabel>{{ 'MENSAJES.GRALS.CHCOMBUSTIBLE' | translate }}:</label>
                    <igx-suffix></igx-suffix>
                  </igx-input-group>
                </div>
                <div class="layout-box__el" igxFlex style="width: 20%">
                  <app-tres-puntos #tresPuntosCombustible [tipoCatalogo]="EnumTresPuntos.CatalogoGeneral" [etiqueta]="'GRIDS.EXP_INSUMO.COL_CODIGO'"
                                   [porcentaje]="100" [verLimpiar]="false" [agregarCodigo]="true"
                                   (eventFilaSeleccionada)="filaSeleccionada($event, 6)"
                                   (eventAgregarCodigo)="agregarCodigo($event, 6)" [readOnlyInput]="false"
                                   [desactivarInput]="esMaestro" [hiddenBtn]="esMaestro"></app-tres-puntos>
                </div>
                <div class="layout-box__el" igxFlex style="width: 40%">
                  <igx-input-group>
                    <input #desCombustible igxInput type="text" [disabled]="esMaestro"/>
                    <label igxLabel>{{ 'GRIDS.EXP_INSUMO.COL_DESCRIPCION_LARGA' | translate }}:</label>
                    <igx-suffix></igx-suffix>
                  </igx-input-group>
                </div>
                <div class="layout-box__el" igxFlex style="width: 15%">
                  <app-tres-puntos #tresPuntosUniCombustible [tipoCatalogo]="EnumTresPuntos.Unidades"
                                   [etiqueta]="'GRIDS.EXP_INSUMO.COL_UNIDAD'" [porcentaje]="100" [verLimpiar]="false"
                                   [readOnlyInput]="false" [desactivarInput]="esMaestro"
                                   [hiddenBtn]="esMaestro"></app-tres-puntos>
                </div>
                <div class="layout-box__el" igxFlex>
                  <igx-input-group>
                    <input #costoCombustible id="costoCombustible" igxInput class="rightInput" type="text"
                           [igxTextSelection]="true" [disabled]="esMaestro"
                           (blur)="regenerarFormato($event, true, true, this.formatDecImporte.digitsInfo)"/>
                    <label igxLabel>{{ 'MENSAJES.GRALS.COSTO' | translate }}:</label>
                    <igx-suffix></igx-suffix>
                  </igx-input-group>
                </div>
              </div>
            </div>
            <div class="layout-box" igxLayout style="padding-top: 2px;">
              <div class="layout-box" igxLayout igxLayoutDir="row">
                <div class="layout-box__el" igxFlex style="width: 25%">
                  <igx-input-group>
                    <input igxInput type="text" [disabled]="true"/>
                    <label igxLabel>{{ 'MENSAJES.GRALS.CHLUBRICANTES' | translate }}:</label>
                    <igx-suffix></igx-suffix>
                  </igx-input-group>
                </div>
                <div class="layout-box__el" igxFlex style="width: 20%">
                  <app-tres-puntos #tresPuntosLubricante [tipoCatalogo]="EnumTresPuntos.CatalogoGeneral" [etiqueta]="'GRIDS.EXP_INSUMO.COL_CODIGO'"
                                   [porcentaje]="100" [verLimpiar]="false" [agregarCodigo]="true"
                                   (eventFilaSeleccionada)="filaSeleccionada($event, 7)"
                                   (eventAgregarCodigo)="agregarCodigo($event, 7)" [readOnlyInput]="false"
                                   [desactivarInput]="esMaestro" [hiddenBtn]="esMaestro"></app-tres-puntos>
                </div>
                <div class="layout-box__el" igxFlex style="width: 40%">
                  <igx-input-group>
                    <input #desLubricante igxInput type="text" [disabled]="esMaestro"/>
                    <label igxLabel>{{ 'GRIDS.EXP_INSUMO.COL_DESCRIPCION_LARGA' | translate }}:</label>
                    <igx-suffix></igx-suffix>
                  </igx-input-group>
                </div>
                <div class="layout-box__el" igxFlex style="width: 15%">
                  <app-tres-puntos #tresPuntosUniLubricante [tipoCatalogo]="EnumTresPuntos.Unidades"
                                   [etiqueta]="'GRIDS.EXP_INSUMO.COL_UNIDAD'" [porcentaje]="100" [verLimpiar]="false"
                                   [readOnlyInput]="false" [desactivarInput]="esMaestro"
                                   [hiddenBtn]="esMaestro"></app-tres-puntos>
                </div>
                <div class="layout-box__el" igxFlex>
                  <igx-input-group>
                    <input #costoLubricante id="costoLubricante" igxInput class="rightInput" type="text"
                           [igxTextSelection]="true" [disabled]="esMaestro"
                           (blur)="regenerarFormato($event, true, true, this.formatDecImporte.digitsInfo)"/>
                    <label igxLabel>{{ 'MENSAJES.GRALS.COSTO' | translate }}:</label>
                    <igx-suffix></igx-suffix>
                  </igx-input-group>
                </div>
              </div>
            </div>
            <div class="layout-box" igxLayout style="padding-top: 2px;">
              <div class="layout-box" igxLayout igxLayoutDir="row">
                <div class="layout-box__el" igxFlex style="width: 25%">
                  <igx-input-group>
                    <input igxInput type="text" [disabled]="true"/>
                    <label igxLabel>{{ 'MENSAJES.GRALS.CHOTRASFUENTESENERGIA' | translate }}:</label>
                    <igx-suffix></igx-suffix>
                  </igx-input-group>
                </div>
                <div class="layout-box__el" igxFlex style="width: 20%">
                  <app-tres-puntos #tresPuntosOtrasFEnergia [tipoCatalogo]="EnumTresPuntos.CatalogoGeneral"
                                   [etiqueta]="'GRIDS.EXP_INSUMO.COL_CODIGO'" [porcentaje]="100" [verLimpiar]="false"
                                   [agregarCodigo]="true"
                                   (eventFilaSeleccionada)="filaSeleccionada($event, 8)"
                                   (eventAgregarCodigo)="agregarCodigo($event, 8)" [readOnlyInput]="false"
                                   [desactivarInput]="esMaestro" [hiddenBtn]="esMaestro"></app-tres-puntos>
                </div>
                <div class="layout-box__el" igxFlex style="width: 40%">
                  <igx-input-group>
                    <input #desOtrasFEnergia igxInput type="text" [disabled]="esMaestro"/>
                    <label igxLabel>{{ 'GRIDS.EXP_INSUMO.COL_DESCRIPCION_LARGA' | translate }}:</label>
                    <igx-suffix></igx-suffix>
                  </igx-input-group>
                </div>
                <div class="layout-box__el" igxFlex style="width: 15%">
                  <app-tres-puntos #tresPuntosUniOtrasFEnergia [tipoCatalogo]="EnumTresPuntos.Unidades"
                                   [etiqueta]="'GRIDS.EXP_INSUMO.COL_UNIDAD'" [porcentaje]="100" [verLimpiar]="false"
                                   [readOnlyInput]="false" [desactivarInput]="esMaestro"
                                   [hiddenBtn]="esMaestro"></app-tres-puntos>
                </div>
                <div class="layout-box__el" igxFlex>
                  <igx-input-group>
                    <input #costoOtrasFEnergia id="costoOtrasFEnergia" igxInput class="rightInput" type="text"
                           [igxTextSelection]="true" [disabled]="esMaestro"
                           (blur)="regenerarFormato($event, true, true, this.formatDecImporte.digitsInfo)"/>
                    <label igxLabel>{{ 'MENSAJES.GRALS.COSTO' | translate }}:</label>
                    <igx-suffix></igx-suffix>
                  </igx-input-group>
                </div>
              </div>
            </div>
            <div class="layout-box" igxLayout style="padding-top: 2px">
              <div class="layout-box__el" igxFlex style="width: 25%">
                <igx-input-group>
                  <input #vidaEconomicaHrs igxInput class="rightInput" type="text" [disabled]="true"/>
                  <label igxLabel>{{ 'MENSAJES.GRALS.CHVIDAECONOMICA' | translate }}(Hrs):</label>
                </igx-input-group>
              </div>
              <div class="layout-box__el" igxFlex style="width: 20%">
                <igx-input-group>
                  <input #vidaEconomicaHrsLlantas id="vidaEconomicaHrsLlantas" igxInput class="rightInput"
                         type="number" [disabled]="esMaestro" (blur)="regenerarFormato($event, false)"
                         [igxTextSelection]="true"/>
                  <label igxLabel>{{ 'MENSAJES.GRALS.CHLLANTAS' | translate }}:</label>
                </igx-input-group>
              </div>
              <div class="layout-box__el" igxFlex style="width: 20%">
                <igx-input-group>
                  <input #vidaEconomicaHrsPzaEsp id="vidaEconomicaHrsPzaEsp" igxInput class="rightInput" type="number"
                         [disabled]="esMaestro" (blur)="regenerarFormato($event, false)" [igxTextSelection]="true"/>
                  <label igxLabel>{{ 'MENSAJES.GRALS.CHPIEZASESPECIALES' | translate }}:</label>
                </igx-input-group>
              </div>
              <div class="layout-box__el" igxFlex style="width: 54%">
                <igx-input-group>
                  <igx-prefix>
                    {{ 'MENSAJES.GRALS.CHVALORMAQUINARIA' | translate }}
                  </igx-prefix>
                  <input #valorMaquinaria igxInput class="rightInput" type="text" [disabled]="true"/>
                </igx-input-group>
              </div>
            </div>
          </igx-tab-content>
        </igx-tab-item>
        <igx-tab-item>
          <igx-tab-header>
            <span igxTabHeaderLabel>{{ 'MENSAJES.GRALS.CHCARGOFIJO' | translate }}</span>
          </igx-tab-header>
          <igx-tab-content style="padding-top: 10px">
            <div class="layout-box" igxLayout>
              <div class="layout-box__el" igxFlex style="width: 55%">
                <igx-card>
                    <igx-card-header style="padding-bottom: 0">
                      <label igxCardHeaderSubtitle></label>
                    </igx-card-header>
                    <igx-card-content style="padding-top: -7px">
                      <div class="layout-box" igxLayout>
                        <div class="layout-box__el" igxFlex>
                          <igx-input-group style="padding-top: 5px; padding-bottom: 5px;">
                            <igx-prefix>
                              {{ 'MENSAJES.GRALS.CHVIDAECONOMICA' | translate }}(Hrs):
                            </igx-prefix>
                            <input #cfVidaEconomicaHrs id="cfVidaEconomicaHrs" igxInput class="rightInput"
                                   type="number" [disabled]="esMaestro" (blur)="regenerarFormato($event, false)"
                                   [igxTextSelection]="true"/>
                          </igx-input-group>
                          <igx-input-group style="padding-top: 5px; padding-bottom: 5px;">
                            <igx-prefix>
                              {{ 'MENSAJES.GRALS.CHHORASTRABAJADASAÑO' | translate }}:
                            </igx-prefix>
                            <input #hrsTrabajadasXAnio id="hrsTrabajadasXAño" igxInput class="rightInput" type="number"
                                   [disabled]="esMaestro" (blur)="regenerarFormato($event, false)"
                                   [igxTextSelection]="true"/>
                          </igx-input-group>
                          <igx-input-group style="padding-top: 5px; padding-bottom: 5px;">
                            <igx-prefix>
                              {{ 'MENSAJES.GRALS.CHVALORRESCATEPOR' | translate }}(%):
                            </igx-prefix>
                            <input #valorRescatePor id="valorRescatePor" igxInput class="rightInput" type="text"
                                   [disabled]="esMaestro" (blur)="regenerarFormato($event, false, true)"
                                   [igxTextSelection]="true"/>
                            <igx-suffix>%</igx-suffix>
                          </igx-input-group>
                          <igx-input-group style="padding-top: 5px; padding-bottom: 5px;">
                            <igx-prefix>
                              {{ 'MENSAJES.GRALS.CHTASAINTERES' | translate }}:
                            </igx-prefix>
                            <input #tasaInteres id="tasaInteres" igxInput class="rightInput" type="text"
                                   [disabled]="esMaestro" (blur)="regenerarFormato($event, false, true,'1.4-4')"
                                   [igxTextSelection]="true"/>
                            <igx-suffix>%</igx-suffix>
                          </igx-input-group>
                          <igx-input-group style="padding-top: 5px; padding-bottom: 5px;">
                            <igx-prefix>
                              {{ 'MENSAJES.GRALS.CHPRIMAANUALPROSEG' | translate }}:
                            </igx-prefix>
                            <input #primaAnualProSeg id="primaAnualProSeg" igxInput class="rightInput" type="text"
                                   [disabled]="esMaestro" (blur)="regenerarFormato($event, false, true)"
                                   [igxTextSelection]="true"/>
                            <igx-suffix>%</igx-suffix>
                          </igx-input-group>
                          <igx-input-group style="padding-top: 5px; padding-bottom: 5px;">
                            <igx-prefix>
                              {{ 'MENSAJES.GRALS.CHFACTORMANTENIMIENTO' | translate }}:
                            </igx-prefix>
                            <input #factorMantenimiento id="factorMantenimiento" igxInput class="rightInput"
                                   type="text" [disabled]="esMaestro"
                                   (blur)="regenerarFormato($event, false, true,'1.4-4')" [igxTextSelection]="true"/>
                          </igx-input-group>
                        </div>
                      </div>
                    </igx-card-content>
                  </igx-card>
              </div>
              <div class="layout-box__el" igxFlex style="width: 45%">
                <igx-card>
                    <igx-card-header style="padding-bottom: 0">
                      <label igxCardHeaderSubtitle></label>
                    </igx-card-header>
                    <igx-card-content style="padding-top: -7px">
                      <div class="layout-box" igxLayout>
                        <div class="layout-box__el" igxFlex>
                          <igx-input-group style="padding-top: 5px; padding-bottom: 5px;">
                            <igx-prefix>
                              {{ 'MENSAJES.GRALS.CHDEPRECIACION' | translate }}:
                            </igx-prefix>
                            <input #depreciacion igxInput class="rightInput" type="text" [disabled]="true"/>
                            <label igxLabel>{{ 'MENSAJES.GRALS.COSTO' | translate }} M.N.:</label>
                          </igx-input-group>
                          <igx-input-group style="padding-top: 5px; padding-bottom: 5px;">
                            <igx-prefix>
                              {{ 'MENSAJES.GRALS.CHINVERSION' | translate }}:
                            </igx-prefix>
                            <input #inversion igxInput class="rightInput" type="text" [disabled]="true"/>
                            <label igxLabel>{{ 'MENSAJES.GRALS.COSTO' | translate }} M.N.:</label>
                          </igx-input-group>
                          <igx-input-group style="padding-top: 5px; padding-bottom: 5px;">
                            <igx-prefix>
                              {{ 'MENSAJES.GRALS.CHSEGUROS' | translate }}:
                            </igx-prefix>
                            <input #seguro igxInput class="rightInput" type="text" [disabled]="true"/>
                            <label igxLabel>{{ 'MENSAJES.GRALS.COSTO' | translate }} M.N.:</label>
                          </igx-input-group>
                          <igx-input-group style="padding-top: 5px; padding-bottom: 5px;">
                            <igx-prefix>
                              {{ 'MENSAJES.GRALS.CHMANTENIMIENTO' | translate }}:
                            </igx-prefix>
                            <input #mantenimiento igxInput class="rightInput" type="text" [disabled]="true"/>
                            <label igxLabel>{{ 'MENSAJES.GRALS.COSTO' | translate }} M.N.:</label>
                          </igx-input-group>
                          <hr class="igx-divider2">
                          <igx-input-group style="padding-top: 5px; padding-bottom: 5px;">
                            <igx-prefix>
                              {{ 'MENSAJES.GRALS.CHTOTALCARGOFIJOS' | translate }}:
                            </igx-prefix>
                            <input #totalCF igxInput class="rightInput" type="text" [disabled]="true"/>
                            <label igxLabel>{{ 'MENSAJES.GRALS.COSTO' | translate }} M.N.:</label>
                          </igx-input-group>
                        </div>
                      </div>
                    </igx-card-content>
                  </igx-card>
              </div>
            </div>
          </igx-tab-content>
        </igx-tab-item>
        <igx-tab-item>
          <igx-tab-header>
            <span igxTabHeaderLabel>{{ 'MENSAJES.GRALS.CHCONSUMOS' | translate }}</span>
          </igx-tab-header>
          <igx-tab-content style="padding-top: 10px">
            <div class="layout-box" igxLayout>
              <div class="layout-box__el" igxFlex style="width: 50%; text-align: center;">
                <div class="layout-box" igxLayout>
                  <div class="layout-box__el" igxFlex>
                    <igx-prefix>
                      {{ 'MENSAJES.GRALS.CHTIPOCALLUBCOM' | translate }}
                    </igx-prefix>
                    <igx-radio-group [alignment]="alignmentRadioH" (change)="cambioTipoLubCom($event)">
                      <igx-radio [(ngModel)]="rTipoLubCom" value="1" [disabled]="esMaestro"
                                 style="padding-right: 10px">{{ 'MENSAJES.GRALS.CHDETALLADO' | translate }}
                      </igx-radio>
                      <igx-radio [(ngModel)]="rTipoLubCom" value="2" [disabled]="esMaestro"
                                 style="padding-right: 10px">{{ 'MENSAJES.GRALS.CHSINDETALLE' | translate }}
                      </igx-radio>
                    </igx-radio-group>
                  </div>
                </div>
<!--                <igx-divider [middle]="true" type="solid"></igx-divider>-->
                <div class="layout-box" igxLayout>
                  <div class="layout-box__el" igxFlex>
                    <igx-prefix>
                      {{ 'MENSAJES.GRALS.CHPOTENCIA' | translate }}
                    </igx-prefix>
                    <igx-input-group style="padding-bottom: 5px;">
                      <igx-prefix>
                        <igx-prefix>
                          {{ 'MENSAJES.GRALS.CHPOTENCIA' | translate }}:
                        </igx-prefix>
                        <igx-input-group>
                          <input #potenciaDescripcion igxInput type="text" [disabled]="esMaestro"
                                 [igxTextSelection]="true"/>
                        </igx-input-group>
                      </igx-prefix>
                      <input #potenciaValor id="potenciaValor" igxInput class="rightInput" [disabled]="esMaestro"
                             (blur)="regenerarFormato($event, false, true)" [igxTextSelection]="true" type="text"/>
                    </igx-input-group>
                    <igx-input-group>
                      <igx-prefix>
                        {{ 'MENSAJES.GRALS.CHFACTOROPERACION' | translate }}(%):
                      </igx-prefix>
                      <input #factorOperacionPor id="factorOperacionPor" igxInput class="rightInput"
                             [disabled]="esMaestro" (blur)="regenerarFormato($event, false, true)"
                             [igxTextSelection]="true" type="text"/>
                      <igx-suffix>%</igx-suffix>
                    </igx-input-group>
                    <hr class="igx-divider3">
                    <igx-input-group>
                      <igx-prefix>
                        {{ 'MENSAJES.GRALS.CHPOTENCIAOPERACION' | translate }}:
                      </igx-prefix>
                      <input #potenciaOpeTotal igxInput class="rightInput" type="text" [disabled]="true"/>
                    </igx-input-group>
                  </div>
                </div>
                <div class="layout-box" igxLayout>
                  <div class="layout-box__el" igxFlex>
                    <igx-prefix>
                      {{ 'MENSAJES.GRALS.CHCOMBUSTIBLE' | translate }}
                    </igx-prefix>
                    <igx-radio-group [alignment]="alignmentRadioH" (change)="cambioTipoCom($event)"
                                     style="text-align: center;">
                      <igx-radio [(ngModel)]="rCombustible" value="1" [disabled]="esMaestro"
                                 style="padding-right: 10px">{{ 'MENSAJES.GRALS.CHGASOLINA' | translate }}
                      </igx-radio>
                      <igx-radio [(ngModel)]="rCombustible" value="2" [disabled]="esMaestro"
                                 style="padding-right: 10px">{{ 'MENSAJES.GRALS.CHDIESEL' | translate }}
                      </igx-radio>
                      <igx-radio [(ngModel)]="rCombustible" value="3" [disabled]="esMaestro"
                                 style="padding-right: 10px">{{ 'MENSAJES.GRALS.CHOTROS' | translate }}
                      </igx-radio>
                    </igx-radio-group>
                    <igx-input-group [hidden]="rTipoLubCom === '1'">
                      <igx-prefix>
                        {{ 'MENSAJES.GRALS.CHCOMBUSTIBLE' | translate }} x hra:
                      </igx-prefix>
                      <input #combustibleXHora id="combustibleXHora" igxInput class="rightInput" [disabled]="esMaestro"
                             (blur)="regenerarFormato($event, false, true, '1.4-4')" [igxTextSelection]="true"
                             type="text"/>
                    </igx-input-group>
                    <igx-input-group [hidden]="rTipoLubCom !== '1'">
                      <igx-prefix>
                        {{ 'MENSAJES.GRALS.CHFACTORESCOMBUSTIBLE' | translate }}:
                      </igx-prefix>
                      <input #factorCombustible id="factorCombustible" igxInput class="rightInput"
                             [disabled]="esMaestro" (blur)="regenerarFormato($event, false, true, '1.4-4')"
                             [igxTextSelection]="true" type="text"/>
                    </igx-input-group>
                    <hr class="igx-divider3">
                    <igx-input-group>
                      <igx-prefix>
                        {{ 'MENSAJES.GRALS.CHCONSUMO' | translate }}(lts):
                      </igx-prefix>
                      <input #consumoLts id="consumoLts" igxInput class="rightInput" [disabled]="esMaestro"
                             (blur)="regenerarFormato($event, false, true, '1.4-4')" [igxTextSelection]="true"
                             type="text"/>
                    </igx-input-group>
                  </div>
                </div>
              </div>
              <div class="layout-box__el" igxFlex style="width: 50%; text-align: center;">
                <div class="layout-box" igxLayout>
                  <div class="layout-box__el" igxFlex>
                    <igx-prefix>
                      {{ 'MENSAJES.GRALS.CHOTRASFUENTESENERGIA' | translate }}
                    </igx-prefix>
                    <igx-input-group style="padding-top: 9px;">
                      <igx-prefix>
                        {{ 'MENSAJES.GRALS.CHFACTOROTRASFUENTES' | translate }}:
                      </igx-prefix>
                      <input #factorOtrasFuentes id="factorOtrasFuentes" igxInput class="rightInput"
                             [disabled]="esMaestro" (blur)="regenerarFormato($event, false, true, '1.4-4')"
                             [igxTextSelection]="true" type="text"/>
                    </igx-input-group>
                  </div>
                </div>
                <div class="layout-box" igxLayout>
                  <div class="layout-box__el" igxFlex>
                    <igx-prefix>
                      {{ 'MENSAJES.GRALS.CHLUBRICANTE' | translate }}
                    </igx-prefix>
                    <igx-input-group [hidden]="rTipoLubCom === '1'" style="padding-bottom: 5px;">
                      <igx-prefix>
                        {{ 'MENSAJES.GRALS.CHLUBRICANTE' | translate }} x hr:
                      </igx-prefix>
                      <input #lubricanteXHora id="lubricanteXHora" igxInput class="rightInput" [disabled]="esMaestro"
                             (blur)="regenerarFormato($event, false, true, '1.4-4')" [igxTextSelection]="true"
                             type="text"/>
                    </igx-input-group>
                    <igx-input-group [hidden]="rTipoLubCom !== '1'" style="padding-bottom: 5px;">
                      <igx-prefix>
                        {{ 'MENSAJES.GRALS.CHFACTORESLUBRICANTE' | translate }}:
                      </igx-prefix>
                      <input #factorLubricante id="factoLubricante" igxInput class="rightInput" [disabled]="esMaestro"
                             (blur)="regenerarFormato($event, false, true, '1.4-4')" [igxTextSelection]="true"
                             type="text"/>
                    </igx-input-group>
                    <igx-input-group [hidden]="rTipoLubCom !== '1'" style="padding-bottom: 5px;">
                      <igx-prefix>
                        {{ 'MENSAJES.GRALS.CHCONSUMO' | translate }}(lts):
                      </igx-prefix>
                      <input #carterLts id="carterLts" igxInput class="rightInput" [disabled]="esMaestro"
                             (blur)="regenerarFormato($event, false, true)" [igxTextSelection]="true" type="text"/>
                    </igx-input-group>
                    <igx-input-group [hidden]="rTipoLubCom !== '1'" style="padding-bottom: 5px;">
                      <igx-prefix>
                        Hrs {{ 'MENSAJES.GRALS.CHCAMBIO' | translate }}:
                      </igx-prefix>
                      <input #hrsCambio id="hrsCambio" igxInput class="rightInput" [igxTextSelection]="true"
                             type="number" [disabled]="esMaestro" (blur)="regenerarFormato($event, false)"/>
                    </igx-input-group>
                    <hr class="igx-divider3">
                    <igx-input-group style="padding-bottom: 5px;">
                      <input #totalLubricante id="totalLubricante" igxInput class="rightInput" [disabled]="esMaestro"
                             (blur)="regenerarFormato($event, false, true, '1.4-4')" [igxTextSelection]="true"
                             type="text"/>
                    </igx-input-group>
                  </div>
                </div>
              </div>
            </div>
          </igx-tab-content>
        </igx-tab-item>
        <igx-tab-item>
          <igx-tab-header>
            <span igxTabHeaderLabel>{{ 'MENSAJES.GRALS.CHOPERACION' | translate }}</span>
          </igx-tab-header>
          <igx-tab-content style="padding-top: 10px">
            <igx-grid #gridOperacion [data]="dataOperaciones" [primaryKey]="'Control'" [width]="'100%'"
                      [height]="'100%'" [locale]="localGrid"
                      [allowFiltering]="true" [filterMode]="'excelStyleFilter'" [showGroupArea]="true"
                      [pinning]="pinConfigColEnd"
                      (cellEdit)="handleCellEdit($event, gridOperacion, mRowDataOperacion, tresPuntosCodigoOperacion, tresPuntosUnidadOperacion, true)"
                      (cellEditDone)="cellEditDone($event, gridOperacion, tresPuntosCodigoOperacion, mRowDataOperacion)"
                      [rowEditable]="!esMaestro" [batchEditing]="true" [sortingOptions]="sortingOptions"
                      (rowEditEnter)="rowEditEnterOperacion($event)" (rowEditExit)="rowEditExitOperacion()">
              <igx-grid-toolbar>
                <!--        Acciones-->
                <igx-grid-toolbar-actions>
                  <!--                <button *ngIf="!gridOperacion.rowEditable" title="{{ 'BOTONES.EDITAR' | translate}}" igxButton="raised" igxRipple (buttonClick)="abrirEdicion(true)">-->
                  <!--                  <igx-icon>edit</igx-icon>-->
                  <!--                  &lt;!&ndash;        <span>{{ 'BOTONES.EDITAR' | translate}}</span>&ndash;&gt;-->
                  <!--                </button>-->
                  <!--                <button *ngIf="gridOperacion.rowEditable" title="{{ 'BOTONES.EDITANDO' | translate}}" igxButton="raised" igxRipple (buttonClick)="abrirEdicion(true)">-->
                  <!--                  <igx-icon>edit</igx-icon>-->
                  <!--                  &lt;!&ndash;        <span>{{ 'BOTONES.EDITANDO' | translate}}</span>&ndash;&gt;-->
                  <!--                </button>-->
                  @if (!esMaestro) {
                    <button title="{{ 'TOOLTIPS.DESHACER' | translate}}" igxButton="contained" igxRipple
                            [disabled]="!gridOperacion.transactions.canUndo" (buttonClick)="undoOperacion()">
                      <igx-icon>undo</igx-icon>
                      <!--        <span>{{ 'BOTONES.DESHACER' | translate}}</span>-->
                    </button>
                    <button title="{{ 'TOOLTIPS.REHACER' | translate}}" igxButton="contained" igxRipple
                            [disabled]="!gridOperacion.transactions.canRedo" (buttonClick)="redoOperacion()">
                      <igx-icon>redo</igx-icon>
                      <!--        <span>{{ 'BOTONES.REHACER' | translate}}</span>-->
                    </button>
                    <button title="{{ 'TOOLTIPS.GUARDAR' | translate}}" igxButton="contained" igxRipple
                            [disabled]="!hasTransactionsOperacion" (buttonClick)="commitOperacion(true)">
                      <igx-icon>save</igx-icon>
                      <!--        <span>{{ 'BOTONES.GUARDAR' | translate}}</span>-->
                    </button>
                    <button title="{{ 'TOOLTIPS.DESCARTAR' | translate}}" igxButton="contained" igxRipple
                            [disabled]="!hasTransactionsOperacion" (buttonClick)="discardOperacion()">
                      <igx-icon>clear</igx-icon>
                      <!--        <span>{{ 'BOTONES.DESCARTAR' | translate}}</span>-->
                    </button>
                  }
                  <igx-grid-toolbar-hiding></igx-grid-toolbar-hiding>
                  <igx-grid-toolbar-pinning></igx-grid-toolbar-pinning>
                </igx-grid-toolbar-actions>
              </igx-grid-toolbar>
              <ng-template igxSortHeaderIcon>
                <igx-icon>north</igx-icon>
              </ng-template>
              <ng-template igxSortAscendingHeaderIcon>
                <igx-icon>north</igx-icon>
              </ng-template>
              <ng-template igxSortDescendingHeaderIcon>
                <igx-icon>south</igx-icon>
              </ng-template>
              <ng-template igxExcelStyleHeaderIcon>
                <igx-icon>filter_alt</igx-icon>
              </ng-template>
              <igx-column field="Codigo" header="{{'GRIDS.EXP_INSUMO.COL_CODIGO' | translate}}" width="140px"
                          [dataType]="'string'" [sortable]="true" [resizable]="true">
                <ng-template igxHeader let-column>
                  <div title="{{'GRIDS.EXP_INSUMO.COL_CODIGO' | translate}}"
                       class="header-required">{{ column.header + '*' }}
                  </div>
                </ng-template>
                <ng-template igxCellEditor  let-cell="cell">
                  <app-tres-puntos #tresPuntosCodigoOperacion [valorDefault]="cell.value" [tipoCatalogo]="EnumTresPuntos.CatalogoGeneral"
                                   [readOnlyInput]="false" [verLimpiar]="false" [porcentaje]="100"
                                   [agregarCodigo]="false"
                                   [filtrarTipo]="[2]"
                                   (eventComponente)="inicializarComponenteCodigoOperacion($event)"
                                   (eventCambioValor)="cambioValorCodigoOperacion($event)"></app-tres-puntos>
                </ng-template>
              </igx-column>
              <igx-column field="TipoInsumo" header="{{'GRIDS.EXP_INSUMO.COL_TIPO_INSUMO' | translate}}" width="90px"
                          [dataType]="'number'" [sortable]="true" [resizable]="true" [editable]="false"
                          [cellStyles]="cellStyles"></igx-column>
              <igx-column field="DescripcionLarga" header="{{'GRIDS.EXP_INSUMO.COL_DESCRIPCION_LARGA' | translate}}"
                          width="360px" [dataType]="'string'" [sortable]="true" [resizable]="true" [hasSummary]="true"
                          [summaries]="'filasSummary' | summaryPipeNeo">
                <ng-template igxHeader let-column>
                  <div title="{{'GRIDS.EXP_INSUMO.COL_DESCRIPCION_LARGA' | translate}}"
                       class="header-required">{{ column.header + '*' }}
                  </div>
                </ng-template>
              </igx-column>
              <igx-column field="Descripcion" header="{{ 'GRIDS.EXP_INSUMO.COL_DESCRIPCION' | translate}}"
                          [dataType]="'string'" width="250px" [sortable]="true" [resizable]="true" [hidden]="true"
                          [editable]="false"></igx-column>
              <igx-column field="Unidad" header="{{'GRIDS.EXP_INSUMO.COL_UNIDAD' | translate}}" width="100px"
                          [dataType]="'string'" [sortable]="true" [resizable]="true">
                <ng-template igxHeader let-column>
                  <div title="{{'GRIDS.EXP_INSUMO.COL_UNIDAD' | translate}}"
                       class="header-required">{{ column.header + '*' }}
                  </div>
                </ng-template>
                <ng-template igxCellEditor let-cell="cell">
                  <app-tres-puntos #tresPuntosUnidadOperacion [valorDefault]="cell.value" [tipoCatalogo]="EnumTresPuntos.Unidades"
                                   [readOnlyInput]="false" [verLimpiar]="false" [porcentaje]="100"
                                   (eventComponente)="inicializarComponenteUnidadOperacion($event)"
                                   (eventCambioValor)="cambioValorUnidadOperacion($event)"></app-tres-puntos>
                </ng-template>
              </igx-column>
              @if (esMoneda1) {
                <igx-column field="CostoMoneda1" header="{{'GRIDS.EXP_INSUMO.COL_COSTO_M1' | translate}}" width="130px"
                            [dataType]="'currency'" [sortable]="true" [resizable]="true" [pipeArgs]="formatDecImporte"
                            [hidden]="!esMoneda1" [disableHiding]="!esMoneda1"></igx-column>
              }
              @if (!esMoneda1) {
                <igx-column field="CostoMoneda2" header="{{'GRIDS.EXP_INSUMO.COL_COSTO_M2' | translate}}" width="130px"
                            [dataType]="'currency'" [sortable]="true" [resizable]="true" [pipeArgs]="formatDecImporte"
                            [hidden]="esMoneda1" [disableHiding]="esMoneda1"></igx-column>
              }
              <igx-column field="TipoOperacion" header="/" width="70px" [dataType]="'string'" [sortable]="true"
                          [resizable]="true" [editable]="false" [cellStyles]="cellStyles"></igx-column>
              <igx-column field="Volumen" header="{{ 'GRIDS.MATRIZ.COL_CANT' | translate}}" width="120px"
                          [dataType]="'number'" [sortable]="true" [resizable]="true"
                          [pipeArgs]="formatColCantidad6Dec"></igx-column>
              @if (esMoneda1) {
                <igx-column field="ImporteMoneda1" header="{{ 'GRIDS.MATRIZ.COL_IMPORTE_M1' | translate}}"
                            [dataType]="'currency'" width="150px" [sortable]="true" [resizable]="true"
                            [editable]="false" [cellStyles]="cellStyles" [hasSummary]="true" [summaries]="'monedaSummary' | summaryPipeNeo"
                            [pipeArgs]="formatDecImporte" [hidden]="!esMoneda1"
                            [disableHiding]="!esMoneda1"></igx-column>
              }
              @if (!esMoneda1) {
                <igx-column field="ImporteMoneda2" header="{{ 'GRIDS.MATRIZ.COL_IMPORTE_M2' | translate}}"
                            [dataType]="'currency'" width="150px" [sortable]="true" [resizable]="true"
                            [editable]="false" [cellStyles]="cellStyles" [hasSummary]="true" [summaries]="'monedaSummary' | summaryPipeNeo"
                            [pipeArgs]="formatDecImporte" [hidden]="esMoneda1" [disableHiding]="esMoneda1"></igx-column>
              }
              <igx-column field="Renglon" header="{{ 'GRIDS.MATRIZ.COL_RENGLON' | translate}}" width="115px"
                          [dataType]="'number'" [sortable]="true" [resizable]="true" [editable]="false" [hidden]="true"
                          [cellStyles]="cellStyles"></igx-column>
              <!--      Acciones Editar, Agregar y Borrar-->
              @if (showActionStripOperacion) {
                <igx-action-strip #actionstripOperacion>
                  @if (gridOperacion.transactions.getAggregatedChanges(false).length <= 3) {
                    <button title="{{ 'TOOLTIPS.NUEVO_REGISTRO' | translate}}" igxButton="fab"
                            [hidden]="!gridOperacion.rowEditable" style="margin-right: 5px"
                            (buttonClick)="beginAddRowByIndexNeo(gridOperacion, actionstripOperacion.context.index)">
                      <igx-icon>add</igx-icon>
                    </button>
                  }
                  <button title="{{ 'TOOLTIPS.EDITAR_REGISTRO' | translate}}" igxButton="fab" igxRipple style="margin-right: 5px"
                          [hidden]="!gridOperacion.rowEditable" (buttonClick)='startEdit(actionstripOperacion.context)'>
                    <igx-icon>edit</igx-icon>
                  </button>
                  <button title="{{ 'TOOLTIPS.BORRAR_REGISTRO' | translate}}" igxButton="fab"
                          [hidden]="(actionstripOperacion.context && actionstripOperacion.context.deleted) || !gridOperacion.rowEditable"
                          (buttonClick)="borrarOperacion(actionstripOperacion.context)">
                    <igx-icon>delete</igx-icon>
                  </button>
                </igx-action-strip>
              }
            </igx-grid>
          </igx-tab-content>
        </igx-tab-item>
        <igx-tab-item>
          <igx-tab-header>
            <span igxTabHeaderLabel>{{ 'MENSAJES.GRALS.CHOTROSCONSUMOS' | translate }}</span>
          </igx-tab-header>
          <igx-tab-content style="padding-top: 10px">
            <igx-grid #gridOtrosConsumos [data]="dataOtrosConsumos" [primaryKey]="'Control'" [width]="'100%'"
                      [height]="'100%'" [locale]="localGrid"
                      [allowFiltering]="true" [filterMode]="'excelStyleFilter'" [showGroupArea]="true"
                      [pinning]="pinConfigColEnd"
                      (cellEdit)="handleCellEdit($event, gridOtrosConsumos, mRowDataOtrosConsumos, tresPuntosCodigoOtroCons, tresPuntosUnidadOtroCons, false)"
                      (cellEditDone)="cellEditDone($event, gridOtrosConsumos, tresPuntosCodigoOtroCons, mRowDataOtrosConsumos)"
                      [rowEditable]="!esMaestro" [batchEditing]="true" [sortingOptions]="sortingOptions"
                      (rowEditEnter)="rowEditEnterOtroCons($event)" (rowEditExit)="rowEditExitOtroCons()">
              <igx-grid-toolbar>
                <!--        Acciones-->
                <igx-grid-toolbar-actions>
                  <!--                <button *ngIf="!gridOperacion.rowEditable" title="{{ 'BOTONES.EDITAR' | translate}}" igxButton="raised" igxRipple (buttonClick)="abrirEdicion(true)">-->
                  <!--                  <igx-icon>edit</igx-icon>-->
                  <!--                  &lt;!&ndash;        <span>{{ 'BOTONES.EDITAR' | translate}}</span>&ndash;&gt;-->
                  <!--                </button>-->
                  <!--                <button *ngIf="gridOperacion.rowEditable" title="{{ 'BOTONES.EDITANDO' | translate}}" igxButton="raised" igxRipple (buttonClick)="abrirEdicion(true)">-->
                  <!--                  <igx-icon>edit</igx-icon>-->
                  <!--                  &lt;!&ndash;        <span>{{ 'BOTONES.EDITANDO' | translate}}</span>&ndash;&gt;-->
                  <!--                </button>-->
                  @if (!esMaestro) {
                    <button title="{{ 'TOOLTIPS.DESHACER' | translate}}" igxButton="contained" igxRipple
                            [disabled]="!gridOtrosConsumos.transactions.canUndo" (buttonClick)="undoOtrosCons()">
                      <igx-icon>undo</igx-icon>
                      <!--        <span>{{ 'BOTONES.DESHACER' | translate}}</span>-->
                    </button>
                    <button title="{{ 'TOOLTIPS.REHACER' | translate}}" igxButton="contained" igxRipple
                            [disabled]="!gridOtrosConsumos.transactions.canRedo" (buttonClick)="redoOtrosCons()">
                      <igx-icon>redo</igx-icon>
                      <!--        <span>{{ 'BOTONES.REHACER' | translate}}</span>-->
                    </button>
                    <button title="{{ 'TOOLTIPS.GUARDAR' | translate}}" igxButton="contained" igxRipple
                            [disabled]="!hasTransactionsOtroCons" (buttonClick)="commitOtrosCons(true)">
                      <igx-icon>save</igx-icon>
                      <!--        <span>{{ 'BOTONES.GUARDAR' | translate}}</span>-->
                    </button>
                    <button title="{{ 'TOOLTIPS.DESCARTAR' | translate}}" igxButton="contained" igxRipple
                            [disabled]="!hasTransactionsOtroCons" (buttonClick)="discardOtrosCons()">
                      <igx-icon>clear</igx-icon>
                      <!--        <span>{{ 'BOTONES.DESCARTAR' | translate}}</span>-->
                    </button>
                  }
                  <igx-grid-toolbar-hiding></igx-grid-toolbar-hiding>
                  <igx-grid-toolbar-pinning></igx-grid-toolbar-pinning>
                </igx-grid-toolbar-actions>
              </igx-grid-toolbar>
              <ng-template igxSortHeaderIcon>
                <igx-icon>north</igx-icon>
              </ng-template>
              <ng-template igxSortAscendingHeaderIcon>
                <igx-icon>north</igx-icon>
              </ng-template>
              <ng-template igxSortDescendingHeaderIcon>
                <igx-icon>south</igx-icon>
              </ng-template>
              <ng-template igxExcelStyleHeaderIcon>
                <igx-icon>filter_alt</igx-icon>
              </ng-template>
              <igx-column field="Codigo" header="{{'GRIDS.EXP_INSUMO.COL_CODIGO' | translate}}" width="140px"
                          [dataType]="'string'" [sortable]="true" [resizable]="true">
                <ng-template igxHeader let-column>
                  <div title="{{'GRIDS.EXP_INSUMO.COL_CODIGO' | translate}}"
                       class="header-required">{{ column.header + '*' }}
                  </div>
                </ng-template>
                <ng-template igxCellEditor name="Codigo" #codigoEditorTemplate let-cell="cell">
                  <app-tres-puntos #tresPuntosCodigoOtroCons [valorDefault]="cell.value" [tipoCatalogo]="EnumTresPuntos.CatalogoGeneral"
                                   [readOnlyInput]="false" [verLimpiar]="false" [porcentaje]="100"
                                   [agregarCodigo]="false"
                                   (eventComponente)="inicializarComponenteCodigoOtroCons($event)"
                                   (eventCambioValor)="cambioValorCodigoOtroCons($event)"></app-tres-puntos>
                </ng-template>
              </igx-column>
              <igx-column field="TipoInsumo" header="{{'GRIDS.EXP_INSUMO.COL_TIPO_INSUMO' | translate}}" width="90px"
                          [dataType]="'number'" [sortable]="true" [resizable]="true" [editable]="false"
                          [cellStyles]="cellStyles">
                <ng-template igxHeader let-column>
                  <div title="{{'GRIDS.EXP_INSUMO.COL_TIPO_INSUMO' | translate}}"
                       class="header-required">{{ column.header + '*' }}
                  </div>
                </ng-template>
              </igx-column>
              <igx-column field="DescripcionLarga" header="{{'GRIDS.EXP_INSUMO.COL_DESCRIPCION_LARGA' | translate}}"
                          width="360px" [dataType]="'string'" [sortable]="true" [resizable]="true" [hasSummary]="true"
                          [summaries]="'filasSummary' | summaryPipeNeo">
                <ng-template igxHeader let-column>
                  <div title="{{'GRIDS.EXP_INSUMO.COL_DESCRIPCION_LARGA' | translate}}"
                       class="header-required">{{ column.header + '*' }}
                  </div>
                </ng-template>
              </igx-column>
              <igx-column field="Descripcion" header="{{ 'GRIDS.EXP_INSUMO.COL_DESCRIPCION' | translate}}"
                          [dataType]="'string'" width="250px" [sortable]="true" [resizable]="true" [hidden]="true"
                          [editable]="false"></igx-column>
              <igx-column field="Unidad" header="{{'GRIDS.EXP_INSUMO.COL_UNIDAD' | translate}}" width="100px"
                          [dataType]="'string'" [sortable]="true" [resizable]="true">
                <ng-template igxHeader let-column>
                  <div title="{{'GRIDS.EXP_INSUMO.COL_UNIDAD' | translate}}"
                       class="header-required">{{ column.header + '*' }}
                  </div>
                </ng-template>
                <ng-template igxCellEditor #unidadEditorTemplate let-cell="cell">
                  <app-tres-puntos #tresPuntosUnidadOtroCons [valorDefault]="cell.value" [tipoCatalogo]="EnumTresPuntos.Unidades"
                                   [readOnlyInput]="false" [verLimpiar]="false" [porcentaje]="100"
                                   (eventComponente)="inicializarComponenteUnidadOtroCons($event)"
                                   (eventCambioValor)="cambioValorUnidadOtroCons($event)"></app-tres-puntos>
                </ng-template>
              </igx-column>
              @if (esMoneda1) {
                <igx-column field="CostoMoneda1" header="{{'GRIDS.EXP_INSUMO.COL_COSTO_M1' | translate}}" width="130px"
                            [dataType]="'currency'" [sortable]="true" [resizable]="true" [pipeArgs]="formatDecImporte"
                            [hidden]="!esMoneda1" [disableHiding]="!esMoneda1"></igx-column>
              }
              @if (!esMoneda1) {
                <igx-column field="CostoMoneda2" header="{{'GRIDS.EXP_INSUMO.COL_COSTO_M2' | translate}}" width="130px"
                            [dataType]="'currency'" [sortable]="true" [resizable]="true" [pipeArgs]="formatDecImporte"
                            [hidden]="esMoneda1" [disableHiding]="esMoneda1"></igx-column>
              }
              <igx-column field="TipoOperacion" header="/" width="70px" [dataType]="'string'" [sortable]="true"
                          [resizable]="true" [editable]="false" [cellStyles]="cellStyles"></igx-column>
              <igx-column field="Volumen" header="{{ 'GRIDS.MATRIZ.COL_CANT' | translate}}" width="120px"
                          [dataType]="'number'" [sortable]="true" [resizable]="true"
                          [pipeArgs]="formatColCantidad6Dec"></igx-column>
              @if (esMoneda1) {
                <igx-column field="ImporteMoneda1" header="{{ 'GRIDS.MATRIZ.COL_IMPORTE_M1' | translate}}"
                            [dataType]="'currency'" width="150px" [sortable]="true" [resizable]="true"
                            [editable]="false" [cellStyles]="cellStyles" [hasSummary]="true" [summaries]="'monedaSummary' | summaryPipeNeo"
                            [pipeArgs]="formatDecImporte" [hidden]="!esMoneda1"
                            [disableHiding]="!esMoneda1"></igx-column>
              }
              @if (!esMoneda1) {
                <igx-column field="ImporteMoneda2" header="{{ 'GRIDS.MATRIZ.COL_IMPORTE_M2' | translate}}"
                            [dataType]="'currency'" width="150px" [sortable]="true" [resizable]="true"
                            [editable]="false" [cellStyles]="cellStyles" [hasSummary]="true" [summaries]="'monedaSummary' | summaryPipeNeo"
                            [pipeArgs]="formatDecImporte" [hidden]="esMoneda1" [disableHiding]="esMoneda1"></igx-column>
              }
              <igx-column field="Renglon" header="{{ 'GRIDS.MATRIZ.COL_RENGLON' | translate}}" width="115px"
                          [dataType]="'number'" [sortable]="true" [resizable]="true" [editable]="false" [hidden]="true"
                          [cellStyles]="cellStyles"></igx-column>
              <!--      Acciones Editar, Agregar y Borrar-->
              @if (showActionStripOtrosConsumos) {
                <igx-action-strip #actionstripOtroCons>
                  @if (gridOtrosConsumos.transactions.getAggregatedChanges(false).length <= 2) {
                    <button title="{{ 'TOOLTIPS.NUEVO_REGISTRO' | translate}}" igxButton="fab"
                            [hidden]="!gridOtrosConsumos.rowEditable" style="margin-right: 5px"
                            (buttonClick)="beginAddRowByIndexNeo(gridOtrosConsumos, actionstripOtroCons.context.index)">
                      <igx-icon>add</igx-icon>
                    </button>
                  }
                  <button title="{{ 'TOOLTIPS.EDITAR_REGISTRO' | translate}}" igxButton="fab" igxRipple style="margin-right: 5px"
                          [hidden]="!gridOtrosConsumos.rowEditable" (buttonClick)='startEdit(actionstripOtroCons.context)'>
                    <igx-icon>edit</igx-icon>
                  </button>
                  <button title="{{ 'TOOLTIPS.BORRAR_REGISTRO' | translate}}" igxButton="fab"
                          [hidden]="(actionstripOtroCons.context && actionstripOtroCons.context.deleted) || !gridOtrosConsumos.rowEditable"
                          (buttonClick)="borrarOtrosCons(actionstripOtroCons.context)">
                    <igx-icon>delete</igx-icon>
                  </button>
                </igx-action-strip>
              }
            </igx-grid>
          </igx-tab-content>
        </igx-tab-item>
        <igx-tab-item>
          <igx-tab-header>
            <span igxTabHeaderLabel>{{ 'MENSAJES.GRALS.CHDETALLE' | translate }}</span>
          </igx-tab-header>
          <igx-tab-content style="padding-top: 10px">
            <div class="layout-box" igxLayout>
              <div class="layout-box__el" igxFlex style="width: 25%"></div>
              <div class="layout-box__el" igxFlex style="width: 60%">
                <div class="layout-box" igxLayout>
                    <div class="layout-box__el" igxFlex style="text-align: center;">
                      <igx-input-group style="padding-top: 3px; padding-bottom: 3px;">
                        <igx-prefix>
                          {{ 'MENSAJES.GRALS.CHMARCA' | translate }}:
                        </igx-prefix>
                        <input #marca igxInput type="text" [disabled]="esMaestro"/>
                      </igx-input-group>
                      <igx-input-group style="padding-top: 3px; padding-bottom: 3px;">
                        <igx-prefix>
                          {{ 'MENSAJES.GRALS.CHMODELO' | translate }}:
                        </igx-prefix>
                        <input #modelo igxInput type="text" [disabled]="esMaestro"/>
                      </igx-input-group>
                      <igx-input-group style="padding-top: 3px; padding-bottom: 3px;">
                        <igx-prefix>
                          {{ 'MENSAJES.GRALS.CHNUMEROSERIE' | translate }}:
                        </igx-prefix>
                        <input #numeroSerie igxInput type="text" [disabled]="esMaestro"/>
                      </igx-input-group>
                      <igx-input-group style="padding-top: 3px; padding-bottom: 3px;">
                        <igx-prefix>
                          {{ 'MENSAJES.GRALS.CHCAPACIDAD' | translate }}:
                        </igx-prefix>
                        <input #capacidad igxInput type="text" [disabled]="esMaestro"/>
                      </igx-input-group>
                      <igx-input-group style="padding-top: 3px; padding-bottom: 3px;">
                        <igx-prefix>
                          {{ 'MENSAJES.GRALS.CHUBICACION' | translate }}:
                        </igx-prefix>
                        <input #ubicacion igxInput type="text" [disabled]="esMaestro"/>
                      </igx-input-group>
                      <igx-input-group style="padding-top: 3px; padding-bottom: 3px;">
                        <igx-prefix>
                          {{ 'MENSAJES.GRALS.CHVIDAUTIL' | translate }}:
                        </igx-prefix>
                        <input #vidaUtil igxInput type="text" [disabled]="esMaestro"/>
                      </igx-input-group>
                      <igx-input-group style="padding-top: 3px; padding-bottom: 3px;">
                        <igx-prefix>
                          {{ 'MENSAJES.GRALS.CHPROPIETARIO' | translate }}:
                        </igx-prefix>
                        <input #propietario igxInput type="text" [disabled]="esMaestro"/>
                      </igx-input-group>
                      <igx-prefix>
                        {{ 'MENSAJES.GRALS.CHDISPONIBILIDAD' | translate }}
                      </igx-prefix>
                      <igx-radio-group [alignment]="alignmentRadioH" (change)="cambioDisponibilidad($event)">
                        <igx-radio [(ngModel)]="rDisponibilidad" value="1"
                                   [disabled]="esMaestro">{{ 'MENSAJES.GRALS.CHPROPIO' | translate }}
                        </igx-radio>
                        <igx-radio [(ngModel)]="rDisponibilidad" value="2"
                                   [disabled]="esMaestro">{{ 'MENSAJES.GRALS.CHPORCOMPRAR' | translate }}
                        </igx-radio>
                        <igx-radio [(ngModel)]="rDisponibilidad" value="3"
                                   [disabled]="esMaestro">{{ 'MENSAJES.GRALS.CHALQUILER' | translate }}
                        </igx-radio>
                      </igx-radio-group>
                    </div>
                  </div>
              </div>
              <div class="layout-box__el" igxFlex style="width: 25%"></div>
            </div>
          </igx-tab-content>
        </igx-tab-item>
        <igx-tab-item>
          <igx-tab-header>
            <span igxTabHeaderLabel>{{ 'MENSAJES.GRALS.VISTA_PREVIA' | translate }}</span>
            <button igxButton="contained" igxSuffix (buttonClick)="descagarArchivoLocal()"
                    [disabled]="esMaestro">
              <igx-icon class="neo-text-inverse">file_download</igx-icon>
            </button>
          </igx-tab-header>
          <igx-tab-content style="padding-top: 10px">
            <igx-spreadsheet #spreadsheet height="100%" width="100%" isFormulaBarVisible="false"
                             (activeWorksheetChanged)="activeWorksheetChanged($event)"
                             (userPromptDisplaying)="userPromptDisplaying($event)"
                             (contextMenuOpening)="contextMenuOpening($event)"
                             class="neo-spreadsheet-surface"></igx-spreadsheet>
          </igx-tab-content>
        </igx-tab-item>
      </igx-tabs>
    </div>
    <div class="layout-box" igxLayout style="padding-top: 15px;">
      <div class="layout-box__el" igxFlex style="width: 20%">
        <igx-input-group>
          <input #ttotalCF id="ttotalCF" igxInput class="rightInput" type="text" [disabled]="esMaestro"
                 (blur)="regenerarFormato($event, true, true, this.formatDecImporte.digitsInfo)"/>
          <label igxLabel>{{ 'MENSAJES.GRALS.CHCARGOFIJO' | translate }}:</label>
        </igx-input-group>
      </div>
      <div class="layout-box__el" igxFlex style="width: 20%">
        <igx-input-group>
          <input #ttotalOperacion igxInput class="rightInput" type="text" [disabled]="true"/>
          <label igxLabel>{{ 'MENSAJES.GRALS.CHOPERACION' | translate }}:</label>
        </igx-input-group>
      </div>
      <div class="layout-box__el" igxFlex style="width: 20%">
        <igx-input-group>
          <input #ttotalConsumos igxInput class="rightInput" type="text" [disabled]="true"/>
          <label igxLabel>{{ 'MENSAJES.GRALS.CHCONSUMOS' | translate }}:</label>
        </igx-input-group>
      </div>
      <div class="layout-box__el" igxFlex style="width: 20%">
        <igx-input-group>
          <input #ttotalCostoActivo igxInput class="rightInput" type="text" [disabled]="true"/>
          <label igxLabel>{{ 'MENSAJES.GRALS.COSTO' | translate }} {{ 'MENSAJES.GRALS.CHACTIVO' | translate }}:</label>
        </igx-input-group>
      </div>
      <div class="layout-box__el" igxFlex style="width: 20%">
        <igx-input-group>
          <input #ttotalCostoEspera igxInput class="rightInput" type="text" [disabled]="true"/>
          <label igxLabel>{{ 'MENSAJES.GRALS.COSTO' | translate }} {{ 'MENSAJES.GRALS.CHESPERA' | translate }}:</label>
        </igx-input-group>
      </div>
      <div class="layout-box__el" igxFlex style="width: 20%">
        <igx-input-group>
          <input #ttotalCostoReserva igxInput class="rightInput" type="text" [disabled]="true"/>
          <label igxLabel>{{ 'MENSAJES.GRALS.COSTO' | translate }} {{ 'MENSAJES.GRALS.CHRESERVA' | translate }}:</label>
        </igx-input-group>
      </div>
    </div>
  </div>
</div>
